import { FC } from 'react'
import Button from '../Button'
import { useTranslation } from 'react-i18next'

type OrderHostingButtonProps = {}

const OrderHostingButton: FC<OrderHostingButtonProps> = ({}) => {
  const { t } = useTranslation()
  return (
    <Button main as="a" href="/hosting">
      {t('order-hosting')}
    </Button>
  )
}

export default OrderHostingButton
